export default __webpack_public_path__ + "static/media/van_2.41e19610.png";